"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { lessonKey, useLearnProgress } from "./progress";

/* The course button. Before anything is ticked (and on the server) it is the
   plain "start" link it has always been; once this browser has progress it
   points at the next lesson instead. */
export default function CourseCta({
  track,
  lessons,
  className = "btn-gold px-6 py-3",
  startLabel = "Start the course",
  startHref,
  arrow = true,
}: {
  track: string;
  lessons: { slug: string; title: string }[];
  className?: string;
  startLabel?: string;
  /* Where "start" goes when nothing is done yet; defaults to the course page. */
  startHref?: string;
  arrow?: boolean;
}) {
  const { done } = useLearnProgress();
  const started = lessons.some((l) => done.has(lessonKey(track, l.slug)));
  const next = lessons.find((l) => !done.has(lessonKey(track, l.slug)));

  const href = started && next ? `/learn/${track}/${next.slug}` : (startHref ?? `/learn/${track}`);
  const label = !started ? startLabel : next ? "Continue the course" : "Revisit the course";

  return (
    <Link href={href} className={className}>
      {label}
      {arrow ? <ArrowRight className="h-4 w-4" aria-hidden /> : null}
    </Link>
  );
}
